import api from "../api";

export const getUsers = async (params = {}) => {
  return api.getApi().get(api.getBaseUrl() + "users", { params });
};

export const getUser = async (id) => {
  return api.getApi().get(api.getBaseUrl() + `users/${id}`);
};

export const getProfile = async () => {
  return api.getApi().get(api.getBaseUrl() + "profile");
};

export const createUser = async (data) => {
  return api.getApi().post(api.getBaseUrl() + "users", data);
};

export const updateUser = async (id, data) => {
  return api.getApi().put(api.getBaseUrl() + `users/${id}`, data);
};

export const deleteUser = async (id) => {
  return api.getApi().delete(api.getBaseUrl() + `users/${id}`);
};

// User Status Management
export const updateUserStatus = async (id, status, reason) => {
  return api.getApi().patch(api.getBaseUrl() + `users/${id}/status`, { status, reason });
};

export const suspendUser = async (id, reason) => {
  return api.getApi().patch(api.getBaseUrl() + `users/${id}/suspend`, { reason });
};

export const banUser = async (id, reason) => {
  return api.getApi().patch(api.getBaseUrl() + `users/${id}/ban`, { reason });
};

export const activateUser = async (id) => {
  return api.getApi().patch(api.getBaseUrl() + `users/${id}/activate`);
};

export const getUserLoginHistory = async (id) => {
  return api.getApi().get(api.getBaseUrl() + `users/${id}/login-history`);
};

// User Preferences (no permission required, user can update own preferences)
export const updatePreferences = async (data) => {
  return api.getApi().put(api.getBaseUrl() + "users/preferences", data);
};

export const getPreferences = async () => {
  return api.getApi().get(api.getBaseUrl() + "users/preferences");
};

// Bulk Operations
export const bulkUpdateUserStatus = async (userIds, status, reason) => {
  return api.getApi().post(api.getBaseUrl() + "users/bulk/status", { userIds, status, reason });
};

export const bulkSendEmail = async (userIds, subject, message) => {
  return api.getApi().post(api.getBaseUrl() + "users/bulk/email", { userIds, subject, message });
};
